// extracted by mini-css-extract-plugin
module.exports = {"TabsHorizontal":"HorizontalTabs-module_TabsHorizontal_3pM5Z","show":"HorizontalTabs-module_show_fGZaG"};